module.exports = {
      id: "tick-usage",
      viewBox: "0 0 23.788 23.787",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#tick",
      toString: function () {
        return this.url;
      }
    }